import { Injectable } from '@angular/core';
import { Camera, CameraOptions } from '@ionic-native/camera';

@Injectable()
export class CameraService {
    imageProfile: any = null;
    constructor(private camera: Camera) {
    }

    captureImage(width, height, type) {
        var sourceType = null;
        if(type == 'camera'){
            sourceType = this.camera.PictureSourceType.CAMERA;
        }else{
            sourceType = this.camera.PictureSourceType.PHOTOLIBRARY;
        }
        const promise = new Promise((resolve, reject) => {

            const options: CameraOptions = {
                quality: 100,
                destinationType: this.camera.DestinationType.DATA_URL,
                sourceType: sourceType,
                allowEdit: true,
                encodingType: this.camera.EncodingType.PNG,
                targetWidth: width,
                targetHeight: height,
                saveToPhotoAlbum: false,
                correctOrientation: true
            }
            this.camera.getPicture(options).then((imageData) => {
                if (imageData) {
                    this.imageProfile = 'data:image/jpeg;base64,' + imageData;
                    resolve(this.imageProfile);
                }
            }, (err) => {
                reject(err);
                // Handle error
            });
        });

        return promise;
    }
}



// WEBPACK FOOTER //
// ./src/providers/camera-service.ts